import * as types from './actionTypes.clientCodeRunner';
import {
    IRememberProjectApiArgumentsParams,
    IRememberProjectApiResultParams,
    IGetProjectApiHistoryParams,
    IStoreProjectApiHistoryParams,
} from './saga.clientCodeRunner';

export const rememberProjectApiArguments = (params: IRememberProjectApiArgumentsParams) => ({
    type: types.REMEMBER_PROJECT_API_PARAMS_REQ,
    ...params,
});

export const rememberProjectApiResult = (params: IRememberProjectApiResultParams) => ({
    type: types.REMEMBER_PROJECT_API_RESULT_REQ,
    ...params
});

export const getProjectApiHistory = ({ projectId, environment, projectApiName, historyKey, resolve, reject }: IGetProjectApiHistoryParams) => ({
    type: types.GET_PROJECT_API_HISTORY_REQ,
    projectId,
    environment,
    projectApiName,
    historyKey,
    resolve,
    reject
});

export const storeProjectApiHistory = ({ projectId, environment, history, historyKey }: IStoreProjectApiHistoryParams) => ({
    type: types.STORE_PROJECT_API_HISTORY_REQ,
    projectId,
    environment,
    history,
    historyKey
});
